import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Kontakt from "./pages/Kontakt";
import DasInternat from "./pages/DasInternat";
import Schlafi from "./pages/Schlafi";
import CandyPeak from "./pages/CandyPeak";
import EventInfo from "./pages/EventInfo";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/work/das-internat" element={<DasInternat />} />
          <Route path="/work/schlafi" element={<Schlafi />} />
          <Route path="/work/candy-peak" element={<CandyPeak />} />
          <Route path="/eventinfo" element={<EventInfo />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
